
import DivSpan from '@/components/DivSpan'
import fileUpload from '@/components/file-upload'
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Popup from 'vux/src/components/popup/index.vue'
import DatetimePlugin from 'vux/src/plugins/datetime/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'


export default {
name: "material-doc-release-view",
components: {
DatetimePlugin, Confirm, DivSpan,
Grid,
GridItem,
Popup,
fileUpload
},
directives: {
TransferDom
},
data() {
return {
id: '',
list: [],
uploadUrl: process.env.API_ROOT,
ImageUrl: '',
matPlantList: [],
searchData: {},
show: false,
page: 0,
basicDto: {},
techInfoList: [],
techMngList: [],
mallDto: {},
item: 'basic',
index: 0,
codeSort: 'DESC',
showCode: 'basic',
activeForm: {},
generalList: [
{src: require('@/assets/icon/supplier/supplier_base_data.png'), name: '基本信息',code:'basic'},
{src: require('@/assets/icon/supplier/supplier_base_data1.png'), name: '采购信息',code:'procu'},
{src: require('@/assets/icon/supplier/supplier_procurement_organization.png'), name: '商城信息', code:'details'},
{src: require('@/assets/icon/supplier/supplier_more.png'), name: '更多',code:'more'},
{src: require('@/assets/icon/supplier/supplier_base_data.png'), name: '基本单位转换', code:'mall'},
{src: require('@/assets/icon/supplier/supplier_base_data1.png'), name: '工厂信息',code:'plant'},
{src: require('@/assets/icon/supplier/supplier_supply_category.png'), name: '物料文档', code:'publish'},
{src: require('@/assets/icon/supplier/supplier_documents_qualifications.png'), name: '系统信息', code: 'system'}
],
}
},

methods: {
replaceRouter() {
this.show = false;
},
changeShow(list, i) {
if (list[i].contentShow) {
this.$set(list[i], 'contentShow', false);
return;
}
this.$set(list[i], 'contentShow', true);
},
getDetail() {
this.$loadingShow();
this.$get('/api/material/' + this.id).then((data) => {
this.basicDto = data;
if (data.matPicture && data.matPicture.attachFile) {
this.ImageUrl = data.matPicture.attachFile[0].key;
}
this.$loadingHide();
}).catch((error) => {
this.$loadingHide();
});
},
viewDetail(code){
if(code === 'plant'){
this.$router.push(`/mat-plant?matId=${this.id}`);
return;
}
if(code === 'mall'){
this.$router.push(`/mat-unit?matId=${this.id}`);
return;
}
if(code === 'publish'){
this.$router.push('/material-doc-release?matId='+ this.id);
return;
}
this.showCode = code;
}
},
mounted() {
this.id = this.$route.params.id;
this.getDetail();
},


}



// WEBPACK FOOTER //
// ./src/page/material-info-library/material-info-view.vue